export default {"src":"/_next/static/image/public/images/ic_call_white.a16ced3a20c7f8a722e84fe52af50eb7.svg","height":32,"width":33};